<template>
  <div class="d-flex gap-2 flex-wrap justify-content-end">
    <button class="btn btn-outline-success btn-sm" :disabled="disabled" @click="exportExcel">
      Exportar Excel
    </button>
    <button class="btn btn-outline-danger btn-sm" :disabled="disabled" @click="exportPdf">
      Exportar PDF
    </button>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import logoNexyo from '@/assets/logo-nexyo.png';
import { exportReportToExcel, exportReportToPdf } from '@/utils/report-exporter';

export default {
  name: 'ReportExportButtons',
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: '' },
    fileName: { type: String, required: true },
    columns: { type: Array, required: true },
    rows: { type: Array, required: true },
    disabled: { type: Boolean, default: false },
  },
  methods: {
    validateRows() {
      if (this.disabled) return false;
      if (!Array.isArray(this.rows) || this.rows.length === 0) {
        Swal.fire({
          icon: 'info',
          title: 'Sin datos',
          text: 'No hay registros para exportar.',
          confirmButtonColor: '#0d6efd',
        });
        return false;
      }
      return true;
    },
    exportExcel() {
      if (!this.validateRows()) return;
      exportReportToExcel({
        columns: this.columns,
        rows: this.rows,
        fileName: this.fileName,
      });
    },
    async exportPdf() {
      if (!this.validateRows()) return;
      await exportReportToPdf({
        title: this.title,
        subtitle: this.subtitle,
        columns: this.columns,
        rows: this.rows,
        fileName: this.fileName,
        logoUrl: logoNexyo,
      });
    },
  },
};
</script>

